(function($, Drupal) {
  'use strict';

  Drupal.behaviors.size_courses = {
    attach: function(context, settings) {
      function sameHeight(args) {
        let $selector = args;
        let $heights = [];

        // Save the heights of every element into an array
        $($selector).each(function() {
          let $height = $(this).outerHeight();
          $heights.push($height);
        });

        // Get the biggest height
        let $maxHeight = Math.max.apply(null, $heights);
        // Show in the console to verify

        // Set the maxHeight to every selected element
        $($selector).each(function() {
          $(this).css('min-height', $maxHeight);
        });
      }

      function resize_semester() {
        let $semesters, $column_selector, $column_index, $course_index, $row_class, $course, $random_num;
        $semesters = $('.field--name-field-semesters');
        $column_selector = '.paragraph--type--semester:not(.yes) .field--name-field-courses';

        $semesters.each(function(s) {
          $random_num = Math.floor((Math.random() * 100) + 1);
          $(this).attr('id', 'semester-' + s);
          // Grab all course columns
          $('#semester-' + s).find($column_selector).each(function(index) {
            let $next_length = $(this).parent().next().length;
            let $next_next_length = $(this).parent().next().next().length;
            let $prev_full = $(this).parent().prev().hasClass('yes');
            if ($next_length !== 0 || $next_next_length !== 0 || !$prev_full) {
              // Set ID on course column
              $column_index = s + '-' + index;
              $(this).attr('id', 'course-column-' + $column_index);

              $('#course-column-' + $column_index).find('.paragraph--type--course').each(function(i) {
                $course_index = i;
                $row_class = '';
                $course = $('#course-column-' + $column_index).children().eq(i);
                $course.addClass('course-row-' + $course_index + $random_num);
                $row_class = '.course-row-' + $course_index + $random_num;
                sameHeight($row_class);
              });
            }
          });
        });
      }

      if ($(window).width() > 769) {
        resize_semester();
      }

      $(window).resize(function() {
        if ($(window).width() > 769) {
          resize_semester();
        }
        else {
          $('.paragraph--view-mode--course-card').removeAttr('style');
        }
      });
    }
  };
})(jQuery, Drupal);
